// extracted by mini-css-extract-plugin
export var wordContainer = "_kf-0";